import { useSyncExternalStore } from 'react';
import { isOrgHost } from '@/lib/is-org-host';
const subscribe = () => () => undefined;

// The ISR render is shared across hosts, so the server snapshot must stay false.
export const useIsOrgHost = () => {
  return useSyncExternalStore(subscribe, _temp, _temp2);
};
function _temp() {
  return isOrgHost(window.location.host);
}
function _temp2() {
  return false;
}